import React from 'react'
import { Container } from 'react-responsive-grid'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Headroom from 'react-headroom'

// module.exports = React.createClass({
export default class IndexBlog extends React.Component {
  static propTypes () {
    return {
      children: React.PropTypes.any,
    }
  }
  _dispLinks(){
    let links = this.props.route.childRoutes.map( (route) => {
      return <div>
        <div>
          <Link activeClassName='activeLink' to={prefixLink(route.path)}> {route.page.data.title} </Link>
        </div>
      </div>
    });
    return( <div> {links} </div>);
  }
  render () {
    let styles = {
      mainContent: {
        display: 'flex',
        flex: 4,
        borderRightStyle: 'solid',
        borderRightColor: 'rgba(15,15,150,1)',
        borderRightThickness: '1px'
      },
      sideBar: {
        display: 'flex',
        flex: 1,
        padding: '15px'
      },
      container: {
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'flex-start'
      }
    }
    if (this.props.location.pathname === "/blog/"){
        return (
          <div>
            {this.props.children}
            {this._dispLinks()}
          </div>
        );
    }
    return (
      <div className="blogContainer" >
        <div className="blogMainContent">{this.props.children}</div>
        <div className="blogSideBar">{this._dispLinks()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./blog/_template.jsx